import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/_auth/profile/investor/_layout/')({
  component: RouteComponent,
  beforeLoad: () => {
    throw redirect({ to: '/profile/investor/personal-information', replace: true });
  },
});

function RouteComponent() {
  return null;
}
